import CreateNotificationsContainer from './CreateNotificationsContainer';

export default CreateNotificationsContainer;
